<template>
  <svg
    width="45"
    height="53"
    viewBox="0 0 45 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.7636 20.0598C31.8615 19.8193 30.9346 20.3262 30.6849 21.1907L29.4993 25.3048L28.3137 21.1928C28.0662 20.3284 27.1393 19.8215 26.235 20.0619C25.3396 20.3024 24.8109 21.1972 25.0629 22.0616L27.875 31.8106C28.0752 32.5125 28.7411 33 29.4993 33C30.2574 33 30.9233 32.5125 31.1258 31.8106L33.9379 22.0616C34.1877 21.1972 33.6612 20.3002 32.7636 20.0598Z"
      fill="white"
    />
    <path
      d="M18.3125 20C17.381 20 16.625 20.728 16.625 21.625V29.2083C16.625 29.5073 16.373 29.75 16.0625 29.75H14.9375C14.627 29.75 14.375 29.5073 14.375 29.2083V21.625C14.375 20.728 13.619 20 12.6875 20C11.756 20 11 20.728 11 21.625V29.2083C11 31.2992 12.7663 33 14.9375 33H16.0625C18.2337 33 20 31.2992 20 29.2083V21.625C20 20.728 19.244 20 18.3125 20Z"
      fill="white"
    />
    <path
      d="M22.5 53C22.302 53 22.104 52.9735 21.9105 52.9227C21.69 52.8631 0 46.841 0 26.3347V9.77012C0 8.85367 0.576 8.03218 1.45125 7.70535L21.7013 0.144092C22.2165 -0.0480308 22.7857 -0.0480308 23.301 0.144092L43.551 7.70535C44.424 8.03218 45 8.85367 45 9.77012V26.3347C45 46.8432 23.31 52.8653 23.0895 52.9227C22.896 52.9735 22.698 53 22.5 53ZM4.5 11.2916V26.3347C4.5 41.8966 19.269 47.4549 22.5 48.484C25.731 47.4549 40.5 41.8966 40.5 26.3347V11.2916L22.5 4.57175L4.5 11.2916Z"
      fill="white"
    />
  </svg>
</template>
<script>
export default {
    name: 'Shield'
}
</script>